export default async ({ $api, app, $cookies, redirect, route, store }) => {
  const fail = () => {
    redirect(302, app.localePath('/compare-car-insurance/'));
  };

  // !!!: With order created here, taken to this page with "a" href tag
  const identifier = route.query.identifier;
  if (!identifier) {
    return fail();
  }
  await $api('protection/motor_insurance_orders', { identifier, method: 'post' }).then(order => store.commit('order/set', order));

  // !!!: With order already created by button on Optional Addons Page
  // const identifier = $cookies.get('bonkers-ie-car-insurance-order');
  // if (!identifier) {
  //   return fail();
  // }
  // await $api('protection/motor_insurance_orders', { identifier, method: 'get' }).then(order => store.commit('order/set', order));
};
